(function() {
  document.addEventListener('modal.contentLoaded', function() {
    $('.sc-Modal').scTooltips();
  });
}());
